import helpIcon from '@disy/cadenza-icons/info.svg';

import { showPresizedLegacyDialog } from 'cadenza/legacy-dialog/legacy-dialog';
import { LayerProperty } from 'cadenza/map/layer-property';
import { icon } from 'cadenza/utils/icon/icon';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class LayerHelpAction extends LayerAction {

  constructor (layer) {
    super(layer, { label: i18n('help'), icon: icon(helpIcon) });
  }

  executeSync () {
    showPresizedLegacyDialog({
      url: this._helpUrl,
      title: this._layer.get(LayerProperty.NAME),
      zIndex: 3001,
      dialogTitleIcon: 'icon-info-round',
      modal: false
    });
  }

  isSupportedSync () {
    return !!this._helpUrl;
  }

  /**
   * Help url can be relative path to the resource on the server or complete web url.
   * Relative paths are transformed to resource urls
   * Example relative path: /metadata/someHelpContent
   * Example web url: http://somePage/content.html
   *
   * @return {string} The help url
   */
  get _helpUrl () {
    const url = this._layer.get(LayerProperty.HELP_URL);
    if (url && (url.startsWith('http') || url.startsWith('https'))) {
      return url;
    }
    return cadenzaUrl(url);
  }

}
